import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button'; // Importa el botón de Material-UI
import IconButton from '@mui/material/IconButton'; // Importa el botón de Material-UI
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // Importa el ícono de "Regresar"
import { useNavigate } from 'react-router-dom'; // Importa el hook useNavigate

import SoftBox from 'components/SoftBox';
import DashboardLayout from 'prefabsComponents/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'prefabsComponents/Navbars/DashboardNavbar';
import Footer from 'prefabsComponents/Footer';

function BaseLayout({ stickyNavbar, children }) {
    const navigate = useNavigate(); // Inicializa useNavigate

    const handleGoBack = () => {
        navigate(-1); // Navega a la página anterior
    };

    return (
        <DashboardLayout>
            <DashboardNavbar absolute={!stickyNavbar} isMini />
            <SoftBox mt={stickyNavbar ? 3 : 10}>
                <Grid container>
                    <Grid item xs={12}>
                        <IconButton aria-label="delete" onClick={handleGoBack}>
                            <ArrowBackIcon /> Regresar
                        </IconButton>
                    </Grid>
                </Grid>
                {children}
            </SoftBox>
        </DashboardLayout>
    );
}

// Setting default values for the props of BaseLayout
BaseLayout.defaultProps = {
    stickyNavbar: false,
};

// Typechecking props for BaseLayout
BaseLayout.propTypes = {
    stickyNavbar: PropTypes.bool,
    children: PropTypes.node.isRequired,
};

export default BaseLayout;
